
import { z } from "zod";

export const SowChangeHoldLevelValues = ["FULL", "REVENUE_ONLY"] as const;
export const SowChangeHoldLevelSchema = z.enum(SowChangeHoldLevelValues);
export const SowChangeHoldLevel = SowChangeHoldLevelSchema.enum;
export type SowChangeHoldLevel = (typeof SowChangeHoldLevelValues)[number];
export const SowChangeHoldLevelDisplayNames = { "FULL": "Full hold",
"REVENUE_ONLY": "Revenue only", } satisfies Record<SowChangeHoldLevel, string>;
